import type { CourseDetail$result } from './../../../$houdini/artifacts/CourseDetail.d';
import type { Session } from '@supabase/supabase-js';
import { goto } from '$app/navigation';
import type { Course, CourseNavigation } from '$lib/types/hygraph';
import { browser } from "$app/environment";

/**
 * Will return a string as href,
 * that defines where the user should be navigated
 * when entering a course – specific to the user's watch history.
 * @param session
 * @param course
 */
export function getPathToEnterCourseBySession(
	session: Session | null,
	course: CourseDetail$result['course'] | undefined
): string {
	if (!course?.slug) {
		return '/';
	}
	if (session?.user) {
		// TODO: compare against user watch history
		return `/courses/${course.slug}/${course.lessons[0]?.slug}`;
	} else {
		// TODO: set up local storage
		// if user is not logged in -> first lesson
		return `/courses/${course.slug}/${course.lessons[0]?.slug}`;
	}
}

/**
 * Returns currentLesson, nextLesson, previousLesson of a given course & current slug.
 * An easy to consume data structure.
 * @param course
 * @param slug
 * @returns
 */
export function getCourseNavigationBySlug(
	course: Course | null | undefined,
	slug: string
): CourseNavigation {
	if (!slug) {
		throw Error('ERROR in getCourseNavigationBySlug – No slug given. Slug is: ' + slug);
	}

	if (!course || !course.lessons.length) {
		return {
			currentCourse: course || null,
			currentLesson: null,
			nextLesson: null,
			previousLesson: null
		};
	}

	const currentIndex = course?.lessons.findIndex((l) => l?.slug === slug);
	const currentLesson = course?.lessons[currentIndex] || null;
	const nextLesson = course?.lessons[currentIndex + 1] || null;
	const previousLesson = course?.lessons[currentIndex - 1] || null;

	return { currentCourse: course, currentLesson, nextLesson, previousLesson };
}

export function gotoNextLesson(navi: CourseNavigation | undefined) {
	if (!navi?.currentCourse) {
		throw Error('ERROR in gotoNextLesson – No navi or currentCourse given. Navi is: ' + navi);
	}

	const path = `/courses/${navi?.currentCourse?.slug}/${navi?.nextLesson?.slug}`;
	goto(path);
}

export function gotoCourse(navi: CourseNavigation | undefined) {
	if (!navi?.currentCourse) {
		throw Error('ERROR in gotoNextLesson – No navi or currentCourse given. Navi is: ' + navi);
	}

	const path = `/courses/${navi?.currentCourse?.slug}`;
	goto(path);
}

export function reloadCurrentPage() {
	window.location.reload();
}

/**
 * loads the pag
 */
export function redirectBySearchParams(currentUrl: URL, fallbackTargetUrl: string) {
	if (!browser) {
		return;
	}
	let redirect: string = fallbackTargetUrl;

	currentUrl.searchParams.forEach((value, key) => {
		if (key === 'redirect') {
			redirect = value;
		}
	});

	goto(redirect, { replaceState: true });
}
